export default __webpack_public_path__ + "static/factorial-687382cc5ed871457688b725e0a69f53.svg";